import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Piko } from '../components/Piko';
import { ClayButton } from '../components/ClayButton';
import { audio } from '../core/audio';
import { getState } from '../core/storage';
import { t } from '../core/i18n';

export default function StartScreen() {
  const nav = useNavigate();
  const start = () => {
    audio.init();
    audio.playSfx('tap');
    nav(getState().onboarded ? '/home' : '/onboarding');
  };
  return (
    <div className="fixed inset-0 overflow-hidden" style={{ background: 'linear-gradient(180deg,#BEE3FF 0%,#FCF9F2 70%)' }}>
      <div className="absolute inset-0" style={{ backgroundImage: 'url(/assets/backgrounds/bg_home.webp)', backgroundSize: 'cover', backgroundPosition: 'center bottom', opacity: 0.9 }} />
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="relative h-full flex flex-col items-center justify-center gap-6 px-6">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <Piko pose="happy" size={190} />
        </motion.div>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }} className="text-center">
          <h1 className="font-heading text-5xl sm:text-6xl font-bold text-navy tracking-tight drop-shadow-sm">PintarPlay</h1>
          <p className="font-body text-lg text-navy/70 mt-2">{t('tagline')}</p>
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}>
          <ClayButton testId="start-playing-btn" onClick={start} className="px-14">{t('start')}</ClayButton>
        </motion.div>
      </div>
    </div>
  );
}
